<template>
  <div>
    <footer id="footer">
      <div class="footer-inner">
        <div class="atlas-brand-footer-container">
          <div class="atlas-brand-footer-logo">
            <img
              src="../assets/images/tbo_logomark.svg"
              alt="Logo Prescreen"
              class="atlas-brand-logo-footer__image"
            >
          </div>
          <div class="prescreen-brand-footer-address">
            <address>
              <b>TBO Bank</b> <br>
              PO Box 199, Orrick, MO 64077 <br>
              561.462.8527 <br>
              <a>supportteam@tbobank.com</a><br>
            </address>
          </div>
        </div>
        <section class="wrapper">
          <div class="special">
            <h2 class="atlas-footer-important-disclosure__title">
              IMPORTANT DISCLOSURES
            </h2>
            <FooterLinks v-if="showFooterLinks" />
            <p>
              TBO Bank loans are designed to assist with short-term borrowing needs;
              are not intended to be a long-term financial solution and are an expensive form of borrowing.
              We encourage quick repayment to avoid additional finance charges.
            </p>
            <p>
              Loan approval is subject to eligibility, credit check, and underwriting requirements.
              TBO Bank may conduct additional verification through national databases. Rates, terms and conditions apply.
              Lending decisions and funding times are subject to system limitations.
              Late fees, non-sufficient funds/ returned item fees may apply as described in your loan agreement.
            </p>
            <p>
              Loan availability, rates, and terms are subject to change at the sole discretion of TBO Bank.
            </p>
            <p>
              Loans are issued and serviced by TBO Bank, Member FDIC.
            </p>
          </div>
        </section>
        <div class="copyright">
          &copy; {{ new Date().getFullYear() }} TBO Bank. All Rights Reserved.
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import FooterLinks from "./FooterLinks.vue";

export default {
  components: {
    FooterLinks,
  },
  computed: {
    ...mapState("settings", ["settings"]),

    showFooterLinks() {
      return this.settings?.show_apply_footer_links || false;
    }
  }
};
</script>

<style></style>
